import type { ReactNode } from "react";

import { segmentTextByEmphasis } from "../domain/text-emphasis";
import type { EmphasisRules } from "../domain/templates";

export function EmphasizedText({
  text,
  rules,
}: {
  text: string;
  rules: EmphasisRules;
}) {
  return segmentTextByEmphasis(text, rules).map((segment, index) => {
    let content: ReactNode = segment.text;
    if (segment.italic) content = <em>{content}</em>;
    if (segment.bold) content = <strong>{content}</strong>;
    return <span key={`${index}-${segment.text.slice(0, 24)}`}>{content}</span>;
  });
}
